export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceDeliveryTypeInfo: {
        deliveryTypeName: "家族のお知らせ",
        deliveryType: "family_info",
        deliveryPriority: "alert",
      },
      ServiceDeliveryPeriods: [
        {
          serviceDeliveryPeriodId: 7,
          serviceDeliveryPeriodUUid: "deliveryperiod007",
          deliveryFrequencyKbn: 1,
          deliveryToKbn: 2,
          deliveryPeriodDays: 30,
          deliveryStartTime: "10:00",
          deliveryEndTime: "12:00"
        }
      ]
    }
  }
}